var exports = {
  "k": "xe564cbfb--a6a32d--container",
};

module.exports = exports;
